<section class="notification--container">
  <fl-top-menu-notifications-toolbar
    [filteredOutNotifications]="filteredOutNotificationCount()"
    [pinned]="pinned()"
    (pinClicked)="pinClick.emit()"
  />
  <fl-top-menu-notifications-list [notifications]="notifications()" />
</section>
